function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonkier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "204px",
    height: "208px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#141414",
    d: "M 116.5,19.5 C 116.611,20.1174 116.944,20.6174 117.5,21C 119.473,21.4955 121.473,21.6621 123.5,21.5C 140.122,26.4616 154.122,35.4616 165.5,48.5C 165.427,50.0269 166.094,51.0269 167.5,51.5C 170.605,54.2749 172.938,57.6082 174.5,61.5C 174.427,63.0269 175.094,64.0269 176.5,64.5C 194.844,104.894 187.844,140.394 155.5,171C 130.701,189.357 103.368,194.357 73.5,186C 36.2722,171.423 16.9389,144.09 15.5,104C 15.3288,97.6871 15.9955,91.5204 17.5,85.5C 19.2766,82.4954 20.2766,79.1621 20.5,75.5C 24.7443,62.6622 31.7443,51.6622 41.5,42.5C 43.7488,41.9202 45.4154,40.5869 46.5,38.5C 54.7859,30.853 64.4526,25.5196 75.5,22.5C 78.1522,22.5905 80.4855,21.9238 82.5,20.5C 93.7219,18.2227 105.055,17.8894 116.5,19.5 Z M 158.5,144.5 C 157.094,144.973 156.427,145.973 156.5,147.5C 134.531,172.91 107.531,180.41 75.5,170C 43.0376,154.34 28.7043,128.506 32.5,92.5C 35.2327,95.2394 38.2327,97.5727 41.5,99.5C 41.56,100.043 41.8933,100.376 42.5,100.5C 43.7969,98.0268 43.7969,95.6934 42.5,93.5C 42.9023,82.3053 45.9023,71.9719 51.5,62.5C 49.4727,62.6621 47.4727,62.4955 45.5,62C 66.6371,36.0436 93.3038,28.0436 125.5,38C 138.654,43.4066 149.321,51.9066 157.5,63.5C 155.716,64.606 153.882,64.606 152,63.5C 150.72,63.6135 149.887,64.2801 149.5,65.5C 152.194,69.5545 154.361,73.8878 156,78.5C 157.109,86.4571 157.776,94.4571 158,102.5C 162.616,100.218 166.283,96.8844 169,92.5C 172.713,111.21 169.213,128.543 158.5,144.5 Z M 76.5,107.5 C 75.8333,106.167 74.8333,105.167 73.5,104.5C 68.1394,95.6786 70.1394,88.8453 79.5,84C 89.6377,82.4578 95.6377,86.7911 97.5,97C 94.4215,108.989 87.4215,112.489 76.5,107.5 Z M 112.5,83.5 C 124.425,82.2623 130.592,87.5956 131,99.5C 122.718,113.767 114.052,114.101 105,100.5C 103.703,93.0985 106.203,87.4318 112.5,83.5 Z M 97.5,121.5 C 98.8361,123.01 100.003,124.677 101,126.5C 101.41,125.099 101.91,123.766 102.5,122.5C 106.841,120.837 109.841,122.171 111.5,126.5C 110.082,131.258 107.082,132.591 102.5,130.5C 101.5,127.833 100.5,127.833 99.5,130.5C 91.6505,132.818 89.1505,130.151 92,122.5C 93.6995,121.594 95.5328,121.261 97.5,121.5 Z M 89.5,145.5 C 97.1739,145.334 104.841,145.5 112.5,146C 115.447,146.112 116.78,147.612 116.5,150.5C 108.92,152.232 101.254,152.732 93.5,152C 90.2415,151.997 87.5749,150.83 85.5,148.5C 86.9014,147.479 88.2347,146.479 89.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.796
    },
    fill: "#888888",
    d: "M 116.5,19.5 C 119.067,19.7215 121.401,20.3882 123.5,21.5C 121.473,21.6621 119.473,21.4955 117.5,21C 116.944,20.6174 116.611,20.1174 116.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.925
    },
    fill: "#636363",
    d: "M 82.5,20.5 C 80.4855,21.9238 78.1522,22.5905 75.5,22.5C 77.5145,21.0762 79.8478,20.4095 82.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.737
    },
    fill: "#747474",
    d: "M 46.5,38.5 C 45.4154,40.5869 43.7488,41.9202 41.5,42.5C 42.5846,40.4131 44.2512,39.0798 46.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.741
    },
    fill: "#8f8f8f",
    d: "M 165.5,48.5 C 166.906,48.9731 167.573,49.9731 167.5,51.5C 166.094,51.0269 165.427,50.0269 165.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#111111",
    d: "M 138.5,65.5 C 138.427,67.0269 139.094,68.0269 140.5,68.5C 149.248,81.0249 149.748,94.0249 142,107.5C 138.799,111.036 135.299,114.203 131.5,117C 137.833,135.351 132.833,149.685 116.5,160C 100.077,166.65 85.9107,163.483 74,150.5C 67.3509,140.575 65.8509,129.909 69.5,118.5C 50.7699,104.522 47.2699,87.5223 59,67.5C 70.3783,55.1474 83.8783,52.1474 99.5,58.5C 114.184,52.6151 127.184,54.9485 138.5,65.5 Z M 76.5,107.5 C 75.8333,106.167 74.8333,105.167 73.5,104.5C 68.1394,95.6786 70.1394,88.8453 79.5,84C 89.6377,82.4578 95.6377,86.7911 97.5,97C 94.4215,108.989 87.4215,112.489 76.5,107.5 Z M 112.5,83.5 C 106.203,87.4318 103.703,93.0985 105,100.5C 114.052,114.101 122.718,113.767 131,99.5C 130.592,87.5956 124.425,82.2623 112.5,83.5 Z M 97.5,121.5 C 98.8361,123.01 100.003,124.677 101,126.5C 101.41,125.099 101.91,123.766 102.5,122.5C 106.841,120.837 109.841,122.171 111.5,126.5C 110.082,131.258 107.082,132.591 102.5,130.5C 101.5,127.833 100.5,127.833 99.5,130.5C 91.6505,132.818 89.1505,130.151 92,122.5C 93.6995,121.594 95.5328,121.261 97.5,121.5 Z M 89.5,145.5 C 88.2347,146.479 86.9014,147.479 85.5,148.5C 87.5749,150.83 90.2415,151.997 93.5,152C 101.254,152.732 108.92,152.232 116.5,150.5C 116.78,147.612 115.447,146.112 112.5,146C 104.841,145.5 97.1739,145.334 89.5,145.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.306
    },
    fill: "#aaaaaa",
    d: "M 174.5,61.5 C 175.906,61.9731 176.573,62.9731 176.5,64.5C 175.094,64.0269 174.427,63.0269 174.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.604
    },
    fill: "#858585",
    d: "M 138.5,65.5 C 139.906,65.9731 140.573,66.9731 140.5,68.5C 139.094,68.0269 138.427,67.0269 138.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.886
    },
    fill: "#717171",
    d: "M 20.5,75.5 C 20.2766,79.1621 19.2766,82.4954 17.5,85.5C 17.7234,81.8379 18.7234,78.5046 20.5,75.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.624
    },
    fill: "#8b8b8b",
    d: "M 42.5,93.5 C 43.7969,95.6934 43.7969,98.0268 42.5,100.5C 41.8933,100.376 41.56,100.043 41.5,99.5C 42.4614,97.7354 42.7947,95.7354 42.5,93.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.682
    },
    fill: "#9e9e9e",
    d: "M 73.5,104.5 C 74.8333,105.167 75.8333,106.167 76.5,107.5C 74.5,107.5 73.5,106.5 73.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.784
    },
    fill: "#808080",
    d: "M 97.5,121.5 C 99.1172,122.038 100.784,122.371 102.5,122.5C 101.91,123.766 101.41,125.099 101,126.5C 100.003,124.677 98.8361,123.01 97.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.227
    },
    fill: "#d0d0d0",
    d: "M 102.5,130.5 C 101.5,130.5 100.5,130.5 99.5,130.5C 100.5,127.833 101.5,127.833 102.5,130.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.533
    },
    fill: "#8e8e8e",
    d: "M 158.5,144.5 C 158.573,146.027 157.906,147.027 156.5,147.5C 156.427,145.973 157.094,144.973 158.5,144.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonkier);
export default __webpack_public_path__ + "static/media/monkier.1a30069222c2cddcf6de872ab70988e4.svg";
export { ForwardRef as ReactComponent };